import { Component, computed, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ColumnList, ColumnPreference, Columns } from '../../models/column-preference';
import { UserColumnPreferencesService } from 'src/app/modules/setting/column-preference/user-column-preferences-service/user-column-preferences.service';


@Component({
    selector: 'app-column-preference-form',
    templateUrl: './column-preference-form.component.html',
    styleUrl: './column-preference-form.component.scss',
    standalone: false
})
export class ColumnPreferenceFormComponent implements OnInit {

  @Input({ required: true }) columnList: WritableSignal<ColumnList[]>;

  @Input({ required: true }) showPreferenceForm: WritableSignal<boolean>;
  
  @Input({ required: true }) title: WritableSignal<string>;

  @Input({required : true}) userPreferenceForm: WritableSignal<ColumnPreference>;
  
  columnForm:FormGroup= new FormGroup([]);

  
  sourceColumnList = signal<Columns | []>([])
  targetColumnList = signal<Columns | []>([]);

  constructor(
    private readonly fb: FormBuilder,
    private readonly userColumnPreferenceService: UserColumnPreferencesService
  ) {}


  /**
   * 
   * @param $event
   */
  OnListUpdation($event:{
    source:ColumnList[],
    target: ColumnList[]
  }) {
    this.sourceColumnList.set([...$event.source]);
    this.targetColumnList.set([...$event.target]);
  }

  ngOnInit(): void {
    this.columnForm = this.fb.group({
      name: new FormControl('', Validators.required),
      description: new FormControl(''),
      id: new FormControl('')
    });
    // Filter enabled columns from the current value of columnList
    this.sourceColumnList.set(
      this.columnList()?.filter((column: ColumnList) => !column.enable)
    );
    this.targetColumnList.set(
      this.columnList()?.filter((column: ColumnList) => column.enable)
    );
    this.setFormValue();
    /**
     * To set picklist height based on the screen
     * space
     */
    document.documentElement.style.setProperty('--picklist-offset', `450px`);
  }

  setFormValue() {
    if(this.userPreferenceForm()?.id) {
      this.columnForm.controls['id'].setValue(this.userPreferenceForm()?.id)
      this.columnForm.controls['description'].setValue(this.userPreferenceForm()?.description)
      this.columnForm.controls['name'].setValue(this.userPreferenceForm()?.name)
    }
  }

  /**
   * To create/update new or existing
   * preference list for the column preference.
   */
  savePreference() {
    const columnList = computed<Columns>(() => {
      const source = this.sourceColumnList().map(col => ({
        ...col,
        enable: false,
      }));

      const target = this.targetColumnList().map(col => ({
        ...col,
        enable: true,
      }));

      return [...target, ...source];
    });
    const payload: ColumnPreference = {
      id: this.columnForm.controls['id'].value? this.columnForm.controls['id'].value: crypto.randomUUID(),
      name: this.columnForm.controls['name'].value??'',
      description: this.columnForm.controls['description'].value??'',
      columnList: columnList(),
      createdDate: this.userPreferenceForm()?.createdDate?? (new Date()).toString(),
      type: this.title().toLowerCase()
    } as ColumnPreference
    /**
     * calling backend service 
     * to save the data.
     */
    this.userColumnPreferenceService.saveUserColumnPreference(payload)
  }

  /**
   * 
   */
  get columnFormValue() {
    return this.columnForm.controls;
  }

  onCancel() {
    this.userColumnPreferenceService.showPreferenceForm.set(false)
  }

}
